export default "__VITE_ASSET__BmKV2CMo__"